import { Component, ViewContainerRef, ViewChild, Input, TemplateRef, OnInit} from '@angular/core';


export class SkyListToolbarItemRendererComponent implements OnInit {
   public template: TemplateRef<any>;
   private container: ViewContainerRef;

  public ngOnInit() {
    if (this.template !== undefined) {
      this.container.createEmbeddedView(this.template, this);
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-list-toolbar-item-renderer',
  template: '<ng-template #container></ng-template>'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'template': [{ type: Input },],
'container': [{ type: ViewChild, args: ['container', { read: ViewContainerRef }, ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
